// // import React from "react";
// // import styles from './Documents.module.css';

// // const Documents = () => {
// //   return (
// //     <div className={styles.container}>
// //       <div className={styles.content}>
// //         <div className={styles.header}>
// //           <h1 className={styles.title}>Documents</h1>
// //         </div>
        
// //         <div className={styles.contentCard}>
// //           <div className={styles.welcomeText}>Hello World! - documents page</div>
// //           <div className={styles.subText}>This is the Documents page. Your content will go here.</div>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default Documents;

// import React, { useState, useRef, useEffect } from 'react';
// import { Download, Loader, AlertCircle } from 'lucide-react';
// import { downloadCenterApi } from '../../../api/downloadcenter/downloadCenterApi';
// import styles from './Documents.module.css';

// const CARDS = [
//     {
//         id: 'invoice',
//         title: 'Invoice',
//         icon: '🧾',
//         description: 'Download invoice PDF by invoice number',
//         fields: ['invoiceno'],
//     },
//     {
//         id: 'msds',
//         title: '3A MSDS',
//         icon: '📄',
//         description: 'Material Safety Data Sheet',
//         fields: ['itemcode', 'packsize'],
//     },
//     {
//         id: 'coa',
//         title: 'COA',
//         icon: '📋',
//         description: 'Certificate of Analysis',
//         fields: ['itemcode', 'packsize', 'batchnum'],
//     },
//     {
//         id: 'qr',
//         title: 'QR Code',
//         icon: '🔲',
//         description: 'Generate QR code for product',
//         fields: ['itemcode', 'packsize', 'batchnum'],
//     },
//     {
//         id: 'density',
//         title: 'Density Label',
//         icon: '📊',
//         description: 'Density Pharmachem product label',
//         fields: ['itemcode', 'packsize', 'batchnum'],
//     },
//     {
//         id: '3alabel',
//         title: '3A Label',
//         icon: '🏷️',
//         description: '3A product label',
//         fields: ['itemcode', 'packsize', 'batchnum'],
//     },
// ];

// const FIELD_LABELS = {
//     invoiceno: 'Invoice No',
//     itemcode:  'Item Code',
//     packsize:  'Pack Size',
//     batchnum:  'Batch Number',
// };

// // ── ItemCode input with suggestion dropdown ────────────────────────────────
// const ItemCodeInput = ({ value, onChange, onSelect }) => {
//     const [suggestions, setSuggestions] = useState([]);
//     const [showDrop,    setShowDrop]    = useState(false);
//     const [loadingSugg, setLoadingSugg] = useState(false);
//     const debounceRef = useRef(null);
//     const wrapperRef  = useRef(null);

//     useEffect(() => {
//         const handler = (e) => {
//             if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
//                 setShowDrop(false);
//             }
//         };
//         document.addEventListener('mousedown', handler);
//         return () => document.removeEventListener('mousedown', handler);
//     }, []);

//     const handleChange = (e) => {
//         const val = e.target.value.toUpperCase();
//         onChange(val);

//         clearTimeout(debounceRef.current);
//         if (val.length >= 2) {
//             debounceRef.current = setTimeout(async () => {
//                 try {
//                     setLoadingSugg(true);
//                     const data = await downloadCenterApi.getItemSuggestions(val);
//                     setSuggestions(data);
//                     setShowDrop(data.length > 0);
//                 } catch {
//                     setSuggestions([]);
//                     setShowDrop(false);
//                 } finally {
//                     setLoadingSugg(false);
//                 }
//             }, 300);
//         } else {
//             setSuggestions([]);
//             setShowDrop(false);
//         }
//     };

//     const handleSelect = (item) => {
//         onChange(item.itemCode);
//         setShowDrop(false);
//         setSuggestions([]);
//         onSelect(item);
//     };

//     return (
//         <div className={styles.inputWrapper} ref={wrapperRef}>
//             <input
//                 type="text"
//                 className={styles.input}
//                 placeholder="Type item code or name..."
//                 value={value}
//                 onChange={handleChange}
//                 onFocus={() => suggestions.length > 0 && setShowDrop(true)}
//                 autoComplete="off"
//             />
//             {loadingSugg && <span className={styles.inputSpinner} />}
//             {showDrop && (
//                 <div className={styles.dropdown}>
//                     {suggestions.map((s, i) => (
//                         <div
//                             key={i}
//                             className={styles.dropdownItem}
//                             onMouseDown={() => handleSelect(s)}
//                         >
//                             <strong>{s.itemCode}</strong>
//                             <span className={styles.dropdownName}>{s.itemName}</span>
//                         </div>
//                     ))}
//                 </div>
//             )}
//         </div>
//     );
// };

// // ── Single card ────────────────────────────────────────────────────────────
// const DownloadCard = ({ card }) => {
//     const [values,    setValues]    = useState({
//         invoiceno: '', itemcode: '', packsize: '', batchnum: '',
//     });
//     const [packSizes, setPackSizes] = useState([]);
//     const [batchNums, setBatchNums] = useState([]);
//     const [loading,   setLoading]   = useState(false);
//     const [error,     setError]     = useState(null);

//     const needsItemCode = card.fields.includes('itemcode');
//     const needsPackSize = card.fields.includes('packsize');
//     const needsBatch    = card.fields.includes('batchnum');

//     const handleItemSelect = async (item) => {
//         setValues(prev => ({ ...prev, itemcode: item.itemCode, packsize: '', batchnum: '' }));
//         setPackSizes([]);
//         setBatchNums([]);

//         if (needsPackSize) {
//             try {
//                 const data = await downloadCenterApi.getPackSizes(item.itemCode);
//                 setPackSizes(data);
//             } catch {
//                 setPackSizes([]);
//             }
//         }
//     };

//     const handlePackSizeChange = async (e) => {
//         const selectedDisplay = e.target.value;
//         const selectedObj = packSizes.find(p => p.displayValue === selectedDisplay);

//         setValues(prev => ({ ...prev, packsize: selectedDisplay, batchnum: '' }));
//         setBatchNums([]);

//         if (needsBatch && selectedObj?.Cat_size_main) {
//             try {
//                 const data = await downloadCenterApi.getBatchNums(selectedObj.Cat_size_main);
//                 setBatchNums(data);
//             } catch {
//                 setBatchNums([]);
//             }
//         }
//     };

//     const validate = () => {
//         for (const field of card.fields) {
//             if (!values[field]?.trim()) {
//                 return `Please fill in: ${FIELD_LABELS[field]}`;
//             }
//         }
//         return null;
//     };

//     const handleDownload = async () => {
//         const err = validate();
//         if (err) { setError(err); return; }
//         setError(null);

//         setLoading(true);
//         try {
//             // TODO: wire up actual download per card type
//             console.log('📥 Download triggered for:', card.id, values);
//             await new Promise(r => setTimeout(r, 500));
//         } catch (e) {
//             setError(e.message || 'Download failed');
//         } finally {
//             setLoading(false);
//         }
//     };

//     return (
//         <div className={styles.card}>
//             <div className={styles.cardHeader}>
//                 <div className={styles.cardMeta}>
//                     <div className={styles.cardIcon}>{card.icon}</div>
//                     <div>
//                         <h3 className={styles.cardTitle}>{card.title}</h3>
//                         <p className={styles.cardDesc}>{card.description}</p>
//                     </div>
//                 </div>
//                 <button
//                     className={styles.downloadBtn}
//                     onClick={handleDownload}
//                     disabled={loading}
//                 >
//                     {loading
//                         ? <Loader size={16} className={styles.spin} />
//                         : <Download size={16} />
//                     }
//                     {loading ? 'Processing...' : 'Download'}
//                 </button>
//             </div>

//             <div className={styles.fieldsRow}>
//                 {card.fields.includes('invoiceno') && (
//                     <div className={styles.fieldGroup}>
//                         <label className={styles.fieldLabel}>Invoice No</label>
//                         <input
//                             type="text"
//                             className={styles.input}
//                             placeholder="Enter invoice number"
//                             value={values.invoiceno}
//                             onChange={e => {
//                                 setValues(prev => ({ ...prev, invoiceno: e.target.value }));
//                                 setError(null);
//                             }}
//                             onKeyDown={e => e.key === 'Enter' && handleDownload()}
//                         />
//                     </div>
//                 )}

//                 {needsItemCode && (
//                     <div className={styles.fieldGroup}>
//                         <label className={styles.fieldLabel}>Item Code</label>
//                         <ItemCodeInput
//                             value={values.itemcode}
//                             onChange={(val) => {
//                                 setValues(prev => ({
//                                     ...prev, itemcode: val, packsize: '', batchnum: ''
//                                 }));
//                                 setPackSizes([]);
//                                 setBatchNums([]);
//                                 setError(null);
//                             }}
//                             onSelect={handleItemSelect}
//                         />
//                     </div>
//                 )}

//                 {needsPackSize && (
//                     <div className={styles.fieldGroup}>
//                         <label className={styles.fieldLabel}>Pack Size</label>
//                         {packSizes.length > 0 ? (
//                             <select
//                                 className={styles.input}
//                                 value={values.packsize}
//                                 onChange={handlePackSizeChange}
//                             >
//                                 <option value="">Select pack size</option>
//                                 {packSizes.map((p, i) => (
//                                     <option key={i} value={p.displayValue}>
//                                         {p.displayValue}
//                                     </option>
//                                 ))}
//                             </select>
//                         ) : (
//                             <input
//                                 type="text"
//                                 className={`${styles.input} ${styles.inputDisabled}`}
//                                 placeholder="Select item code first"
//                                 disabled
//                             />
//                         )}
//                     </div>
//                 )}

//                 {needsBatch && (
//                     <div className={styles.fieldGroup}>
//                         <label className={styles.fieldLabel}>Batch Number</label>
//                         {batchNums.length > 0 ? (
//                             <select
//                                 className={styles.input}
//                                 value={values.batchnum}
//                                 onChange={e => {
//                                     setValues(prev => ({ ...prev, batchnum: e.target.value }));
//                                     setError(null);
//                                 }}
//                             >
//                                 <option value="">Select batch number</option>
//                                 {batchNums.map((b, i) => (
//                                     <option key={i} value={b.batchNum}>
//                                         {b.batchNum}
//                                     </option>
//                                 ))}
//                             </select>
//                         ) : (
//                             <input
//                                 type="text"
//                                 className={`${styles.input} ${styles.inputDisabled}`}
//                                 placeholder="Select pack size first"
//                                 disabled
//                             />
//                         )}
//                     </div>
//                 )}
//             </div>

//             {error && (
//                 <div className={styles.errorBox}>
//                     <AlertCircle size={15} />
//                     <span>{error}</span>
//                 </div>
//             )}
//         </div>
//     );
// };

// // ── Page — matches Documents.jsx layout exactly ────────────────────────────
// const DownloadCenter = () => {
//     return (
//         <div className={styles.container}>
//             <div className={styles.content}>

//                 {/* Header — same as Documents.jsx */}
//                 <div className={styles.header}>
//                     <h1 className={styles.title}>Download Center</h1>
//                     <p className={styles.subtitle}>
//                         Generate and download labels, documents, and QR codes
//                     </p>
//                 </div>

//                 {/* Cards */}
//                 <div className={styles.cardsList}>
//                     {CARDS.map(card => (
//                         <DownloadCard key={card.id} card={card} />
//                     ))}
//                 </div>

//             </div>
//         </div>
//     );
// };

// export default DownloadCenter;

import React, { useState, useRef, useEffect } from 'react';
import { Download, Loader, AlertCircle, CheckCircle } from 'lucide-react';
import { downloadCenterApi ,triggerDownload  } from '../../../api/downloadcenter/downloadCenterApi';
import styles from './Documents.module.css';

// ─────────────────────────────────────────────────────────────────────────────
// Helpers
// ─────────────────────────────────────────────────────────────────────────────


// ─────────────────────────────────────────────────────────────────────────────
// ItemCode autocomplete input
// ─────────────────────────────────────────────────────────────────────────────
const ItemCodeInput = ({ value, onChange, onSelect, placeholder = 'Type item code or name...' }) => {
    const [suggestions, setSuggestions] = useState([]);
    const [showDrop,    setShowDrop]    = useState(false);
    const [busy,        setBusy]        = useState(false);
    const debounceRef = useRef(null);
    const wrapperRef  = useRef(null);

    useEffect(() => {
        const close = (e) => {
            if (wrapperRef.current && !wrapperRef.current.contains(e.target))
                setShowDrop(false);
        };
        document.addEventListener('mousedown', close);
        return () => document.removeEventListener('mousedown', close);
    }, []);

    const handleChange = (e) => {
        const val = e.target.value.toUpperCase();
        onChange(val);
        clearTimeout(debounceRef.current);

        if (val.length >= 2) {
            debounceRef.current = setTimeout(async () => {
                try {
                    setBusy(true);
                    const data = await downloadCenterApi.getItemSuggestions(val);
                    setSuggestions(data);
                    setShowDrop(data.length > 0);
                } catch {
                    setSuggestions([]);
                    setShowDrop(false);
                } finally {
                    setBusy(false);
                }
            }, 250);             // 250ms debounce — fast
        } else {
            setSuggestions([]);
            setShowDrop(false);
        }
    };

    const pick = (item) => {
        onChange(item.itemCode);
        setShowDrop(false);
        setSuggestions([]);
        onSelect(item);
    };

    return (
        <div className={styles.inputWrapper} ref={wrapperRef}>
            <input
                type="text"
                className={styles.input}
                placeholder={placeholder}
                value={value}
                onChange={handleChange}
                onFocus={() => suggestions.length > 0 && setShowDrop(true)}
                autoComplete="off"
            />
            {busy && <span className={styles.inputSpinner} />}
            {showDrop && (
                <div className={styles.dropdown}>
                    {suggestions.map((s, i) => (
                        <div key={i} className={styles.dropdownItem} onMouseDown={() => pick(s)}>
                            <strong>{s.itemCode}</strong>
                            <span className={styles.dropdownName}>{s.itemName}</span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

// ─────────────────────────────────────────────────────────────────────────────
// INVOICE card
// ─────────────────────────────────────────────────────────────────────────────
const InvoiceCard = () => {
    const [invoiceNo, setInvoiceNo] = useState('');
    const [loading,   setLoading]   = useState(false);
    const [error,     setError]     = useState(null);
    const [success,   setSuccess]   = useState(null);

    const handleDownload = async () => {
        if (!invoiceNo.trim()) { setError('Please enter an invoice number'); return; }
        setError(null); setSuccess(null); setLoading(true);
        try {
            const blob = await downloadCenterApi.downloadInvoice(invoiceNo.trim());
            triggerDownload(blob, `Invoice_${invoiceNo.trim()}.pdf`);
            setSuccess('Invoice downloaded successfully');
        } catch (e) {
            setError(e.message || 'Invoice not found or download failed');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={styles.card}>
            <div className={styles.cardHeader}>
                <div className={styles.cardMeta}>
                    <div className={styles.cardIcon}>🧾</div>
                    <div>
                        <h3 className={styles.cardTitle}>Invoice</h3>
                        <p className={styles.cardDesc}>Download invoice PDF by invoice number</p>
                    </div>
                </div>
                <button className={styles.downloadBtn} onClick={handleDownload} disabled={loading}>
                    {loading ? <Loader size={16} className={styles.spin} /> : <Download size={16} />}
                    {loading ? 'Downloading...' : 'Download'}
                </button>
            </div>

            <div className={styles.fieldsRow}>
                <div className={styles.fieldGroup}>
                    <label className={styles.fieldLabel}>Invoice No</label>
                    <input
                        type="text"
                        className={styles.input}
                        placeholder="Enter invoice number e.g. 25216253"
                        value={invoiceNo}
                        onChange={e => { setInvoiceNo(e.target.value); setError(null); setSuccess(null); }}
                        onKeyDown={e => e.key === 'Enter' && handleDownload()}
                    />
                </div>
            </div>

            {error   && <div className={styles.errorBox}><AlertCircle size={15}/><span>{error}</span></div>}
            {success && <div className={styles.successBox}><CheckCircle size={15}/><span>{success}</span></div>}
        </div>
    );
};

// ─────────────────────────────────────────────────────────────────────────────
// 3A COA card  (itemCode + batchNum only — no packsize)
// ─────────────────────────────────────────────────────────────────────────────
const ThreeACOACard = () => {
    const [itemCode,  setItemCode]  = useState('');
    const [batchNums, setBatchNums] = useState([]);
    const [batchNum,  setBatchNum]  = useState('');
    const [loading,   setLoading]   = useState(false);
    const [error,     setError]     = useState(null);
    const [success,   setSuccess]   = useState(null);

    // When user picks a suggestion, load batch numbers via pack-sizes then batch endpoint
    // For 3A COA the itemCode IS the full code (e.g. E027567), no pack size involved
    // Batch nums come from our download-center/batch-nums but using U_ALTCAT = itemCode
    const handleItemSelect = async (item) => {
        setItemCode(item.itemCode);
        setBatchNum('');
        setBatchNums([]);
        setError(null);
        try {
            // For 3A, itemCode from suggestions IS the U_ALTCAT, batch nums use it directly
            const data = await downloadCenterApi.getBatchNums(item.itemCode);
            setBatchNums(data);
        } catch {
            setBatchNums([]);
        }
    };

    const handleDownload = async () => {
        if (!itemCode.trim()) { setError('Please enter an item code'); return; }
        if (!batchNum.trim()) { setError('Please select a batch number'); return; }
        setError(null); setSuccess(null); setLoading(true);
        try {
            const blob = await downloadCenterApi.download3ACOA(itemCode.trim(), batchNum.trim());
            triggerDownload(blob, `COA_${itemCode.trim()}_${batchNum.trim()}.pdf`);
            setSuccess('3A COA downloaded successfully');
        } catch (e) {
            setError(e.message || '3A COA not found');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={styles.card}>
            <div className={styles.cardHeader}>
                <div className={styles.cardMeta}>
                    <div className={styles.cardIcon}>📋</div>
                    <div>
                        <h3 className={styles.cardTitle}>3A COA</h3>
                        <p className={styles.cardDesc}>Certificate of Analysis — 3A / Energy</p>
                    </div>
                </div>
                <button className={styles.downloadBtn} onClick={handleDownload} disabled={loading}>
                    {loading ? <Loader size={16} className={styles.spin} /> : <Download size={16} />}
                    {loading ? 'Downloading...' : 'Download'}
                </button>
            </div>

            <div className={styles.fieldsRow}>
                <div className={styles.fieldGroup}>
                    <label className={styles.fieldLabel}>Item Code</label>
                    <ItemCodeInput
                        value={itemCode}
                        placeholder="Type item code e.g. E027567"
                        onChange={(val) => {
                            setItemCode(val);
                            setBatchNum('');
                            setBatchNums([]);
                            setError(null);
                            setSuccess(null);
                        }}
                        onSelect={handleItemSelect}
                    />
                </div>

                <div className={styles.fieldGroup}>
                    <label className={styles.fieldLabel}>Batch Number</label>
                    {batchNums.length > 0 ? (
                        <select
                            className={styles.input}
                            value={batchNum}
                            onChange={e => { setBatchNum(e.target.value); setError(null); }}
                        >
                            <option value="">Select batch number</option>
                            {batchNums.map((b, i) => (
                                <option key={i} value={b.batchNum}>{b.batchNum}</option>
                            ))}
                        </select>
                    ) : (
                        <input
                            type="text"
                            className={`${styles.input} ${!itemCode ? styles.inputDisabled : ''}`}
                            placeholder={itemCode ? 'Enter batch number manually' : 'Select item code first'}
                            value={batchNum}
                            onChange={e => { setBatchNum(e.target.value.toUpperCase()); setError(null); }}
                            disabled={!itemCode}
                        />
                    )}
                </div>
            </div>

            {error   && <div className={styles.errorBox}><AlertCircle size={15}/><span>{error}</span></div>}
            {success && <div className={styles.successBox}><CheckCircle size={15}/><span>{success}</span></div>}
        </div>
    );
};

// ─────────────────────────────────────────────────────────────────────────────
// DENSITY COA card  (itemCode + packSize → full code, then batchNum)
// ─────────────────────────────────────────────────────────────────────────────
const DensityCOACard = () => {
    const [itemCode,  setItemCode]  = useState('');
    const [packSizes, setPackSizes] = useState([]);
    const [packSize,  setPackSize]  = useState('');
    const [batchNums, setBatchNums] = useState([]);
    const [batchNum,  setBatchNum]  = useState('');
    const [loading,   setLoading]   = useState(false);
    const [error,     setError]     = useState(null);
    const [success,   setSuccess]   = useState(null);

    const handleItemSelect = async (item) => {
        setItemCode(item.itemCode);
        setPackSize(''); setBatchNum('');
        setPackSizes([]); setBatchNums([]);
        setError(null); setSuccess(null);
        try {
            const data = await downloadCenterApi.getPackSizes(item.itemCode);
            setPackSizes(data);
        } catch {
            setPackSizes([]);
        }
    };

    const handlePackSizeChange = async (e) => {
        const selected    = e.target.value;
        const selectedObj = packSizes.find(p => p.displayValue === selected);
        setPackSize(selected);
        setBatchNum(''); setBatchNums([]);
        setError(null);

        if (selectedObj?.Cat_size_main) {
            try {
                const data = await downloadCenterApi.getBatchNums(selectedObj.Cat_size_main);
                setBatchNums(data);
            } catch {
                setBatchNums([]);
            }
        }
    };

    // Full item code for density COA = "DP00001-10g" (Cat_size_main)
    const getFullItemCode = () => {
        const obj = packSizes.find(p => p.displayValue === packSize);
        return obj?.Cat_size_main || itemCode;
    };

    const handleDownload = async () => {
        if (!itemCode.trim()) { setError('Please enter an item code'); return; }
        if (!packSize.trim()) { setError('Please select a pack size'); return; }
        if (!batchNum.trim()) { setError('Please select a batch number'); return; }
        setError(null); setSuccess(null); setLoading(true);
        try {
            const fullCode = getFullItemCode();
            const blob = await downloadCenterApi.downloadDensityCOA(fullCode, batchNum.trim());
            triggerDownload(blob, `DensityCOA_${fullCode}_${batchNum.trim()}.pdf`);
            setSuccess('Density COA downloaded successfully');
        } catch (e) {
            setError(e.message || 'Density COA not found');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={styles.card}>
            <div className={styles.cardHeader}>
                <div className={styles.cardMeta}>
                    <div className={styles.cardIcon}>🔬</div>
                    <div>
                        <h3 className={styles.cardTitle}>Density COA</h3>
                        <p className={styles.cardDesc}>Certificate of Analysis — Density Pharmachem</p>
                    </div>
                </div>
                <button className={styles.downloadBtn} onClick={handleDownload} disabled={loading}>
                    {loading ? <Loader size={16} className={styles.spin} /> : <Download size={16} />}
                    {loading ? 'Downloading...' : 'Download'}
                </button>
            </div>

            <div className={styles.fieldsRow}>
                <div className={styles.fieldGroup}>
                    <label className={styles.fieldLabel}>Item Code</label>
                    <ItemCodeInput
                        value={itemCode}
                        placeholder="Type item code or name..."
                        onChange={(val) => {
                            setItemCode(val);
                            setPackSize(''); setBatchNum('');
                            setPackSizes([]); setBatchNums([]);
                            setError(null); setSuccess(null);
                        }}
                        onSelect={handleItemSelect}
                    />
                </div>

                <div className={styles.fieldGroup}>
                    <label className={styles.fieldLabel}>Pack Size</label>
                    {packSizes.length > 0 ? (
                        <select className={styles.input} value={packSize} onChange={handlePackSizeChange}>
                            <option value="">Select pack size</option>
                            {packSizes.map((p, i) => (
                                <option key={i} value={p.displayValue}>{p.displayValue}</option>
                            ))}
                        </select>
                    ) : (
                        <input
                            type="text"
                            className={`${styles.input} ${styles.inputDisabled}`}
                            placeholder="Select item code first"
                            disabled
                        />
                    )}
                </div>

                <div className={styles.fieldGroup}>
                    <label className={styles.fieldLabel}>Batch Number</label>
                    {batchNums.length > 0 ? (
                        <select
                            className={styles.input}
                            value={batchNum}
                            onChange={e => { setBatchNum(e.target.value); setError(null); }}
                        >
                            <option value="">Select batch number</option>
                            {batchNums.map((b, i) => (
                                <option key={i} value={b.batchNum}>{b.batchNum}</option>
                            ))}
                        </select>
                    ) : (
                        <input
                            type="text"
                            className={`${styles.input} ${styles.inputDisabled}`}
                            placeholder="Select pack size first"
                            disabled
                        />
                    )}
                </div>
            </div>

            {error   && <div className={styles.errorBox}><AlertCircle size={15}/><span>{error}</span></div>}
            {success && <div className={styles.successBox}><CheckCircle size={15}/><span>{success}</span></div>}
        </div>
    );
};

// ─────────────────────────────────────────────────────────────────────────────
// Page
// ─────────────────────────────────────────────────────────────────────────────
const DownloadCenter = () => {
    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <div className={styles.header}>
                    <h1 className={styles.title}>Download Center</h1>
                    <p className={styles.subtitle}>
                        Generate and download invoices, COA documents and labels
                    </p>
                </div>

                <div className={styles.cardsList}>
                    <InvoiceCard />
                    <ThreeACOACard />
                    <DensityCOACard />
                </div>
            </div>
        </div>
    );
};

export default DownloadCenter;